import { Accessibility, ArrowUpRight, Car, Coffee, DoorOpen, Info, MapPin } from "lucide-react";
import { Container } from "@/components/shared/PageHeader";
import { Reveal } from "@/components/shared/Reveal";

const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Halsn%C3%B8y+Kulturhus+S%C3%A6b%C3%B8vik";
const CELLS = [
  ["doors_open", "Dørene opnar", DoorOpen, (v) => `kl. ${v}`],
  ["parking", "Parkering", Car],
  ["accessibility", "Tilgjengelegheit", Accessibility],
  ["cafe", "Kafé og servering", Coffee],
  ["extra", "Verdt å vite", Info],
];

const Cell = ({ icon: Icon, label, children, testId }) => (
  <div className="rule-b pb-6" data-testid={testId}>
    <Icon className="h-5 w-5 text-sol" aria-hidden="true" />
    <h3 className="t-mono mt-4 text-muted-foreground">{label}</h3>
    <div className="mt-2 text-[17px] font-medium leading-snug text-pretty">{children}</div>
  </div>
);

/** Doors, parking, accessibility, café – the event's own words first, the house defaults from site settings behind. */
export const EventPractical = ({ practical, location, site }) => {
  const merged = { parking: site?.practical_parking, accessibility: site?.practical_accessibility, cafe: site?.practical_cafe, ...Object.fromEntries(Object.entries(practical || {}).filter(([, v]) => v)) };
  const items = CELLS.filter(([k]) => merged[k]).map(([k, label, Icon, f]) => ({ k, label, Icon, text: f ? f(merged[k]) : merged[k] }));
  return (
    <section id="praktisk" className="scroll-mt-20 border-t border-border py-16 sm:py-20" data-testid="event-practical" aria-labelledby="practical-title">
      <Container><Reveal>
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-3">
            <p className="t-mono text-muted-foreground">Praktisk</p>
            <h2 id="practical-title" className="t-h2 mt-3 text-balance">Godt å vite før du kjem</h2>
          </div>
          <div className="grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:col-span-9 lg:grid-cols-3">
            {items.map(({ k, label, Icon, text }) => <Cell key={k} icon={Icon} label={label} testId={`event-practical-${k}`}>{text}</Cell>)}
            <Cell icon={MapPin} label="Stad" testId="event-practical-venue">
              <p>{location ? `${location}, ` : ""}Halsnøy Kulturhus</p>
              <p className="mt-0.5 text-[15px] font-normal text-muted-foreground">{site?.address || "Sæbøvik, 5454 Sæbøvik"}</p>
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="u-link mt-2 inline-flex items-center gap-1 text-[14px] font-medium" data-testid="event-practical-maps-link">Vis i Google Maps <ArrowUpRight className="h-3.5 w-3.5" /></a>
            </Cell>
          </div>
        </div>
      </Reveal></Container>
    </section>
  );
};
